module.exports = __webpack_public_path__ + "img/tape_measure.0f8a8811.jpg";